import { mapValues } from 'lodash';
/**
 * Version 29 migrations: migrate "Allow air request to be submitted for" setting
 * for existing event websites to "Invitees & Guests".
 * Default is "Invitees" but earlier the other option was applicable before the setting came in.
 */
export default function v29(website) {
  return {
    ...website,
    eventVersion: 29,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'AirRequest') {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            registrationSettings: {
              ...layoutItem.config.registrationSettings,
              allowedAttendeeTypes: 'inviteeAndGuest'
            }
          }
        };
      }
      return layoutItem;
    })
  };
}
